import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    left: {
        height: "700px",
        width: "100%"
    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
    }
  }));



const Roof = ({active, next, info, state, change, roofs}) => {
    const [value, setValue] = React.useState(info.front.geometry.roofType);
    const [image, setImage] = React.useState();  


    React.useEffect(() => {
        setImage(roofs.find(r => r.field === value)?.image)
    }, [value, roofs])

    React.useEffect(() => {
      change({...state, geometry: {...state.geometry, roofType: encodeURIComponent(value)}})
    }, [value])

    const classes = useStyles();


      





    return <Grid container component={Paper} elevation={0}>

      <Grid item xs={12}>
      {image &&<Box style={{height: 400}}>

         <img style={{objectFit: "cover"}} src={image} alt="Bild på tak" width="100%" height="100%"/>

      </Box>}
            


      </Grid>
      <Container>
        <Box className={classes.container}>
        <br/>
        <Grid item xs={12}>
                    <Typography variant="h3" className={classes.element}>Taktyp</Typography>
                    <Typography variant="subtitle1"  className={classes.element}>Välj en av taktyperna nedan</Typography>
                    <Select
                      value={value}
                      onChange={(event, newValue) => setValue(event.target.value)}
                      fullWidth
                      style={{textAlign: 'left'}}
                    >
                      {roofs.map(roof => <MenuItem value={roof?.field}>{roof?.name}</MenuItem>)}


                    </Select>

                    <Button color="primary" disabled={value === undefined} onClick={event => next()} fullWidth size="large" variant="outlined" className={classes.element}>Fortsätt</Button>

        </Grid>
        </Box>

      </Container>

    </Grid>

};

export default Roof;